import styled from "styled-components";

export const GameClubOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100vh;
`;

export const GameClubAllWrapper = styled.div`
  position: fixed;
  padding: 20px 16px;
  width: 100%;
  height: 100%;
  margin-top: 50px;
`;

export const GameClubAllHeader = styled.div`
  position: fiexd;
  > .input-box {
    width: 100%;
    height: 36px;
    border-radius: 15px;
    background: #43434399;
    display: flex;
    padding: 10px 12px;
    justify-content: space-between;

    > input {
      background: rgba(255, 255, 255, 0);
      outline: none;
      border: none;
      width: 100%;
      color: #fff;

      font-weight: 600;
      font-size: 12px;
    }

    > input::placeholder {
      color: #fff;

      font-weight: 600;
      font-size: 12px;
    }
  }
`;

export const GameClubListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: #fff;
  gap: 5px;

  > .no-data {
    font-size: 12px;
    width: 100%;
    text-align: center;
    padding: 20px;
    color: #b7b7b7;
  }
`;

export const GameClubListItem = styled.div`
  display: flex;
  padding: 8px 10px;
  justify-content: space-between;
  height: 60px;
  box-sizing: border-box;
  border-radius: 8px;
  background: #ffffff0d;

  > div {
    display: flex;
    gap: 10px;
    align-items: center;
  }
`;

export const GameClubAllList3Rank = styled.div`
  position: absolute;
  left: -20px;
  top: -5px;

  > img {
    witdh: 46px;
    height: 41px;
  }

  > .rank {
    position: absolute;
    box-shadow: 0px 4px 4px 0px #00000040;
    top: 7px;
    left: 18.7px;
    width: 9px;
    text-align: center;
    font-size: 14px;
    font-weight: 800;
  }
`;

export const GameClubAllListRank = styled.div`
  position: absolute;
  left: 35px;
  bottom: -8px;

  > img {
    witdh: 25px;
    height: 25px;
  }

  > .rank {
    position: absolute;
    top: 2.5px;
    left: 2.5px;
    font-family: Pretendard;
    font-weight: 700;
    font-size: 8px;
    text-align: center;
    width: 20px;
    height: 20px;
  }
`;

export const GameClubAllListItemLeft = styled.div`
  position: relative;
  padding-left: 15px;

  > .profile {
    width: 35px;
    height: 35px;
    border: 3px solid transparent;
    border-radius: 50%;
    background-image: linear-gradient(#000, #000),
      linear-gradient(142.42deg, #ffcd57 33.13%, #ffffff 50%, #b68411 76.39%);
    background-origin: border-box;
    background-clip: content-box, border-box;
    display: flex;
    align-items: center;
    justify-content: center;

    > img {
      object-fit: cover;
      width: 25px;
      height: 25px;
      border-radius: 50%;
    }
  }

  > .name {
    font-weight: 700;
    font-size: 14px;
  }
`;

export const GameClubAllListItemRight = styled.div`
  > .member {
    font-weight: 600;
    font-size: 14px;
    display: flex;
    align-items: flex-end;
    gap: 5px;

    > .update {
      font-weight: 500;
      font-size: 10px;
      display: flex;
      align-items: center;

      > img {
        witdh: 7px;
        height: auto;
      }
    }
  }

  > .button {
    width: 65px;
    height: 25px;
    gap: 5px;
    border-radius: 8px;

    font-weight: 700;
    font-size: 13px;
    background: #ffffff33;
    line-height: 25px;
    box-sizing: border-box;
    cursor: pointer;
  }
`;

export const GameClubAllListWrapper = styled.div`
  background: #1f212799;
  width: 100%;
  height: 600px;
  overflow-y: auto;
  border-radius: 8px;
  margin-top: 12px;
  padding: 20px 16px 150px;
`;
export const GameClubAllListBottom = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;
  position: relative;

  > .button {
    position: absolute;
    right: 0;
    height: 25px;
    box-sizing: border-box;
    border-radius: 8px;
    padding: 5px 15px;
    background: #6436e7;

    font-weight: 700;
    font-size: 11px;
    color: #fff;
    line-height: 15px;
    cursor: pointer;
  }
`;

export const GameClubAllListPaging = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;

  > .page {
    font-weight: 700;
    font-size: 12px;
    text-align: center;
    color: #ffffff;
    width: 27px;
  }
`;

export const GameClubJoinWrapper = styled.div`
  position: fixed;
  top: 0px;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
`;

export const GameClubJoinContentWrapper = styled.div`
  position: fixed;
  z-index: 100;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% - 52px);
  border-radius: 12px;
  border: 1px solid transparent;
  background-image: linear-gradient(#121212, #121212),
    linear-gradient(
      166.29deg,
      #ba643a 0.22%,
      #ffffff 38.14%,
      #7addeb 66.57%,
      #836623 100%
    );
  background-origin: border-box;
  background-clip: padding-box, border-box;
  padding: 20px 16px 24px;

  > .button {
    width: 100%;
    height: 48px;
    border-radius: 8px;
    padding: 15px;
    background: var(--Purple-300, #6436e7);

    font-weight: 600;
    font-size: 15px;
    line-height: 18px;
    text-align: center;
    color: #fff;
  }

  > .button.edit {
    margin-top: 50px;
  }
`;

export const GameClubJoinWarning = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 50px;
  margin-bottom: 10px;
  gap: 8px;

  > .item {
    display: flex;
    align-items: center;
    gap: 5px;

    font-weight: 600;
    font-size: 12px;
    text-align: center;
    color: #ffffff;
  }
`;

export const GameClubJoinHeader = styled.div`
  display: flex;
  justify-content: space-between;

  > .title {
    color: #fff;

    font-weight: 800;
    font-size: 18px;
  }
`;

export const GameClubJoinContent = styled.div`
  display: flex;
  gap: 10px;
  color: #fff;
  margin-top: 23px;

  > .club-box {
    display: flex;
    flex-direction: column;
    gap: 7px;
  }

  > .club-info {
    width: 100%;
    height: 115px;
    border-radius: 8px;
    padding: 8px;
    background: #ffffff33;
    border: 1px solid transparent;
    background-image: linear-gradient(#000, #000),
      linear-gradient(150.42deg, #ffcd57 33.13%, #ffffff 50%, #b68411 76.39%);
    background-origin: border-box;
    background-clip: padding-box, border-box;
    box-sizing: border-box;
    white-space: pre-wrap;

    > .content {
      font-weight: 500;
      font-size: 11px;
      text-align: left;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 7;
      -webkit-box-orient: vertical;
      line-height: 1.2;
    }
  }
  > textarea {
    border-radius: 8px;
    border: 1px solid transparent;
    background-image: linear-gradient(#000, #000),
      linear-gradient(150.42deg, #ffcd57 33.13%, #ffffff 50%, #b68411 76.39%);
    background-origin: border-box;
    background-clip: padding-box, border-box;
    width: 100%;
    height: 115px;
    padding: 8px;
    box-sizing: border-box;
    outline: none;
    resize: none;
    color: #fff;

    font-weight: 500;
    font-size: 11px;
  }

  > textarea::placeholder {
    color: #a7a7a7;
  }
`;

export const GameClubJoinName = styled.div`
  font-weight: 700;
  font-size: 15px;

  > input {
    outline: none;
    border-radius: 8px;
    border: 1px solid transparent;
    background-image: linear-gradient(#000, #000),
      linear-gradient(165.42deg, #ffcd57 33.13%, #ffffff 50%, #b68411 76.39%);
    background-origin: border-box;
    background-clip: padding-box, border-box;
    width: 84px;
    height: 26px;
    box-sizing: border-box;
    padding: 8px;
    color: #fff;

    font-weight: 500;
    font-size: 11px;
    text-align: center;
  }

  > input::placeholder {
    color: #a7a7a7;
  }
`;

export const GameClubImageUpload = styled.div`
  width: 84px;
  height: 84px;
  border-radius: 50%;

  > .image {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: #d9d9d9;
  }

  > img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
`;

export const GameClubImage = styled.div`
  width: 100%;
  height: 108%;
  background-image: url("/image-web/game/club/profile_image_edit_back.svg");
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  gap: 1.78px;
  > .profile-image {
    margin-top: 15px;
    width: 32px;
    height: 32px;
  }

  > .profile-image.read {
    margin-top: 17px;
    width: 50px;
    height: 50px;
  }

  > .info {
    color: #a7a7a7;
    text-align: center;
    font-family: Pretendard;
    font-size: 9px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.18px;
  }
`;

export const GameClubImageSelectWrapper = styled.div`
  position: absolute;
  top: 111px;
  left: 10px;
  width: calc(100% - 20px);
  height: 93px;
  border-radius: 12px;
  border: 1px solid transparent;
  background-image: linear-gradient(#121212, #121212),
    linear-gradient(
      166.29deg,
      #ba643a 0.22%,
      #ffffff 38.14%,
      #7addeb 66.57%,
      #836623 100%
    );
  background-origin: border-box;
  background-clip: padding-box, border-box;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  padding: 8px 10px;
`;

export const GameClubImageSelectItem = styled.div<{
  isSelected: boolean;
}>`
  width: 25%;
  height: 77px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  border: 1px solid
    ${({ isSelected }) => (isSelected ? "transparent" : "rgb(18, 18, 18)")};
  background-image: ${({ isSelected }) =>
    isSelected
      ? `linear-gradient(#6436E7),
         linear-gradient(
           166.29deg,
           #ba643a 0.22%,
           #ffffff 38.14%,
           #7addeb 66.57%,
           #836623 100%
         )`
      : "none"};
  background-origin: ${({ isSelected }) =>
    isSelected ? "border-box" : "initial"};
  background-clip: ${({ isSelected }) =>
    isSelected ? "padding-box, border-box" : "initial"};
  background-color: ${({ isSelected }) => (isSelected ? "#6436E7" : "#121212")};

  > img {
    width: 50px;
    height: 50px;
  }
  display: flex;
  flex-direction: column;
  > span {
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 9px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.18px;
  }
`;
export const GameClubPopupContent = styled.div`
  font-weight: 600;
  font-size: 20px;
  text-align: center;
  color: #ffffff;
  margin-bottom: 35px;
`;
